<template>
  <div>
    <slot></slot>
    <TextInput :required="true" :disabled="data.fullcopy" @setError="errors.name = $event" v-model="data.name" text="ФИО Выгодоприобретателя" :name="`beneficiary-${index}-name`" @update:modelValue="suggestName($event)" :validation="(v) => v ? ((v.split(' ').filter(el => el.trim()).length < 2) ? 'Заполните поле' : '') : ''" :options="fullnameSuggest" :blurcondition="data.name.split(' ').filter(el => el.trim()).length >= 3" />
    <CheckBox v-if="copyEnabled || data.fullcopy" :name="`beneficiary-${index}-fullcopy`" v-model="data.fullcopy">Заявитель совпадает с&nbsp;выгодоприобритателем</CheckBox>
    <DateInput :required="true" :disabled="data.fullcopy" :validation="birthdateval" @setError="errors.birthdate = $event" :name="`beneficiary-${index}-birthdate`" text="Дата рождения Выгодоприобретателя" :range="false" v-model="data.birthdate" />
    <SelInput :required="true" :disabled="data.fullcopy" text="Документ удостоверяющий личность" :name="`beneficiary-${index}-doctype`" :options="doctypes" v-model="data.doc.type" />
    <ShortFields>
      <NumberInput :required="true" :disabled="data.fullcopy" v-if="dynamicfields.series" mask="####" @setError="errors.series = $event" :filled="(v) => v.length == 4" v-model="data.doc.series" text="Серия документа" :name="`beneficiary-${index}-doc-series`" />
      <NumberInput :required="true" :disabled="data.fullcopy" v-if="dynamicfields.number" mask="######" @setError="errors.number = $event" :filled="(v) => v.length == 6" v-model="data.doc.number" text="Номер документа" :name="`beneficiary-${index}-doc-number`" />
      <TextInput :maxlength="50" :validation="(v) => (v.length > 50) ? 'Не более 50 символов' : ''" :required="true" :disabled="data.fullcopy" v-if="dynamicfields.foreignnumber" @setError="errors.number = $event" v-model="data.doc.number" text="Номер документа" :name="`beneficiary-${index}-doc-foreign-number`" />
    </ShortFields>
    <ShortFields>
      <NumberInput :forceError="CodeError" :required="true" :disabled="data.fullcopy" v-if="dynamicfields.code" mask="###-###" @setError="errors.code = $event" :filled="(v) => v.length == 7" v-model="data.doc.code" text="Код подразделения " :name="`beneficiary-${index}-doc-code`" />
      <DateInput :required="true" :disabled="data.fullcopy" v-if="dynamicfields.releasedate" @setError="errors.releasedate = $event" v-model="data.doc.releasedate" text="Дата выдачи документа" :name="`beneficiary-${index}-doc-releasedate`" />
    </ShortFields>
    <NumberInput mask="############" @setError="errors.INN = $event" :filled="(v) => v.length == 12 || !v.length" v-model="data.INN" text="ИНН Выгодоприобретателя" :name="`beneficiary-${index}-INN`" />
    <CheckBox :disabled="data.fullcopy" :name="`beneficiary-${index}-addresscopy`" v-model="data.addresscopy">Адрес проживания совпадает с адресом Заявителя</CheckBox>
    <div class="step__addressline">
      <TextInput class="step__addressline-main" :required="true" :alignRight="true" :forceError="(!data.fullcopy && data.address.address && !addressIsCorrect) ? 'Укажите полный адрес' : ''" :blurcondition="data.fullcopy ? undefined : houseIsFilled" :disabled="data.addresscopy" @setError="errors.address = $event" :options="dadataVariants" v-model="data.address.address" text="Адрес проживания Выгодоприобретателя" :name="`beneficiary-${index}-address-address`" />
      <TextInput :disabled="data.addresscopy" v-show="!data.address.noflat" class="step__addressline-flat" :required="true" :alignRight="true" v-model="data.address.flat" text="Кв." :name="`beneficiary-${index}-address-flat`" />
    </div>
    <CheckBox :name="`beneficiary-${index}-address-noflat`" v-model="data.address.noflat" :disabled="data.addresscopy">Частный дом</CheckBox>
    <CheckBox :name="`beneficiary-${index}-publicPerson`" v-model="data.publicPerson">Является публичным должностным лицом</CheckBox>
    <div v-if="data.publicPerson">
      <TextInput :required="true" @setError="errors.PDL_name = $event" v-model="data.PDL.name" text="ФИО ПДЛ" :name="`beneficiary-${index}-PDL_name`" :validation="(v) => v ? ((v.split(' ').filter(el => el.trim()).length < 2) ? 'Заполните поле' : '') : ''" :optionsFunction="suggestNameAndReturn" :blurcondition="data.PDL.name.split(' ').filter(el => el.trim()).length >= 3" />
      <h4 class="step__microtitle">Источники происхождения денежных средств</h4>
      <CheckBox :radio_like="true" :name="`beneficiary-${index}-salary`" v-model="data.PDL.income.salary">Заработная плата</CheckBox>
      <CheckBox :radio_like="true" :name="`beneficiary-${index}-pension`" v-model="data.PDL.income.pension">Пенсия</CheckBox>
      <CheckBox :radio_like="true" :name="`beneficiary-${index}-inherit`" v-model="data.PDL.income.inherit">Наследство</CheckBox>
      <CheckBox :radio_like="true" :name="`beneficiary-${index}-savings`" v-model="data.PDL.income.savings">Личные сбережения</CheckBox>
      <CheckBox :radio_like="true" :name="`beneficiary-${index}-percentages`" v-model="data.PDL.income.percentages">Процентный доход по вкладам</CheckBox>
      <CheckBox :radio_like="true" :name="`beneficiary-${index}-business`" v-model="data.PDL.income.business">Доходы от предпринимательской деятельности</CheckBox>
      <TextAreaInput :maxlength="1000" :validation="(v) => (v.length > 1000) ? 'Не более 1000 символов' : ''" @setError="errors.PDL_icome_others = $event" v-model="data.PDL.income.others" text="Иные доходы" :name="`beneficiary-${index}-PDL_income_others`" />
      <TextInput :required="true" @setError="errors.PDL_position = $event" v-model="data.PDL.position" text="Должность ПДЛ" :name="`beneficiary-${index}-PDL_position`" />
      <TextInput :required="true" @setError="errors.PDL_employer = $event" v-model="data.PDL.employer" text="Работодатель ПДЛ" :name="`beneficiary-${index}-PDL_employer`" />
      <div class="step__addressline">
        <TextInput class="step__addressline-main" :required="true" :alignRight="true" :forceError="(data.PDL.employer_address && !PDLaddressIsCorrect) ? 'Укажите полный адрес' : ''" :blurcondition="PDLhouseIsFilled" @setError="errors.PDL_employer_address = $event" :options="dadataVariantsPDL.values" v-model="data.PDL.employer_address.address" text="Адрес работодателя ПДЛ" :name="`beneficiary-${index}-PDL_employer_address`" />
        <TextInput v-show="!data.PDL.employer_address.noflat" class="step__addressline-flat" :required="true" :alignRight="true" v-model="data.PDL.employer_address.flat" text="Кв." :name="`beneficiary-${index}-PDL_employer_address_flat`" />
      </div>
      <CheckBox :name="`beneficiary-${index}-PDL_employer_address_noflat`" v-model="data.PDL.employer_address.noflat">Частный дом</CheckBox>
    </div>
    <SelInput text="Степень родства Заявителя с Застрахованным" :name="`beneficiary-${index}-relationship`" :options="relationships" v-model="data.relationship" />
    <CheckBox :name="`beneficiary-${index}-insuredperson-is-beneficiary`" v-model="data.insuredperson.copy">Застрахованный совпадает с&nbsp;выгодоприобретателем</CheckBox>
    <TextInput :required="true" :disabled="data.insuredperson.copy" @setError="errors.insuredname = $event" v-model="data.insuredperson.name" text="ФИО Застрахованного" :name="`beneficiary-${index}-insuredperson-name`" @update:modelValue="suggestName($event)" :validation="(v) => v ? ((v.split(' ').filter(el => el.trim()).length < 2) ? 'Заполните поле' : '') : ''" :options="fullnameSuggest" :blurcondition="data.insuredperson.name.split(' ').filter(el => el.trim()).length >= 3" />
    <DateInput :validation="birthdateval" :required="true" :disabled="data.insuredperson.copy" @setError="errors.insuredbirthdate = $event" :name="`beneficiary-${index}-insuredperson-birthdate`" text="Дата рождения Застрахованного" :range="false" v-model="data.insuredperson.birthdate" />
    <div class="step__faTCa" v-if="FATCAcondition">
      <RadioGroup :required="true" :title="'Являетесь ли Вы гражданином США?\n(в том числе, при наличии двух или более гражданств)'" :values="['Да', 'Нет']" :name="`beneficiary-${index}-FATCA_USACitizen`" v-model="data.FATCA.USACitizen" />
      <RadioGroup :required="true" :values="['Да', 'Нет']" :title="'Имеется ли у Вас в настоящий момент\nили имелся ли ранее вид на жительство в США (форма I 551 «Green Card»)?'" :name="`beneficiary-${index}-FATCA_USAResidencePermit`" v-model="data.FATCA.USAResidencePermit" />
      <RadioGroup :required="true" :values="['Да', 'Нет']" :title="'Является ли местом Вашего рождения территория США?'" :name="`beneficiary-${index}-FATCA_bornInUSA`" v-model="data.FATCA.bornInUSA" />
      <RadioGroup :required="true" :values="['Да', 'Нет']" :title="'Соответствуете ли Вы критериям долгосрочного пребывания в США?'" :name="`beneficiary-${index}-FATCA_longPeriod`" v-model="data.FATCA.longPeriod" />
      <RadioGroup :required="true" :values="['Да', 'Нет']" :title="'Имеется ли у Вас адрес проживания или почтовый адрес в США?'" :name="`beneficiary-${index}-FATCA_haveaddress`" v-model="data.FATCA.haveaddress" />
      <RadioGroup :required="true" :values="['Да', 'Нет']" :title="'Имеете ли вы основной номер контактного телефона на территории США?'" :name="`beneficiary-${index}-FATCA_havephone`" v-model="data.FATCA.havephone" />
      <RadioGroup :required="true" :values="['Да', 'Нет']" :title="'Подтвердите: Вы являетесь налоговым резидентом США?'" :name="`beneficiary-${index}-FATCA_taxResident`" v-model="data.FATCA.taxResident" />
      <RadioGroup :required="true" :values="['Да', 'Нет']" :title="'Вы отказались от гражданства/вида на жительство в США?'" :name="`beneficiary-${index}-FATCA_renunciation`" v-model="data.FATCA.renunciation" />
      <RadioGroup :required="true" :values="['Да', 'Нет']" :title="'У меня имеется разрешение на постоянное пребывание/вид на жительство в США'" :name="`beneficiary-${index}-FATCA_USAResidencePermit2`" :modelValue="data.FATCA.USAResidencePermit" :disabled="true" v-if="taxResident" />
      <RadioGroup :required="true" :values="['Да', 'Нет']" :title="'Я соответствую критериям долгосрочного пребывания на территории США'" :name="`beneficiary-${index}-FATCA_longPeriod2`" :modelValue="data.FATCA.longPeriod" :disabled="true" v-if="taxResident" />
      <TextInput v-if="taxResident" v-model="data.FATCA.SSN" text="Номер социального страхования США" :name="`beneficiary-${index}-FATCA_SSN`" />
      <TextInput v-if="taxResident" v-model="data.FATCA.ITIN" text="Индивидуальный идентификационный номер налогоплательщика США" :name="`beneficiary-${index}-FATCA_ITIN`" />
      <TextInput v-if="taxResident" v-model="data.FATCA.name" text="ФИО на английском языке в соответствии с документом, удостоверяющим личность" :name="`beneficiary-${index}-FATCA_name`" :required="true" :validation="(v) => v.match(/^[- a-zA-Z]*$/) ? '' : 'Только английские буквы'" mask="E" tokens="E:[-A-Za-z ]:repeated" />
      <CheckBox :smtext="true" :tostart="true" :name="`beneficiary-${index}-FATCA_agreementItsTrue`" v-model="data.FATCA.agreementItsTrue">
        Да, я подтверждаю, что информация, указанная в настоящей форме, является достоверной, и я не возражаю против дополнительной проверки
      </CheckBox>
      <CheckBox :smtext="true" :tostart="true" :name="`beneficiary-${index}-FATCA_agreementIKnowConsequenses`" v-model="data.FATCA.agreementIKnowConsequenses">
        Да, я понимаю, что предоставление ложных, противоречивых или заведомо недостоверных сведений о себе может повлечь ответственность и применение мер в соответствии с применимым законодательством, в том числе, отказ в&nbsp;проведении операций
      </CheckBox>

    </div>
    <div class="step__TRD" v-if="TRDcondition">
      <TextInput :required="true" :disabled="data.TRD.namecopied" v-model="data.TRD.name" text="ФИО налогового резидента" :name="`beneficiary-${index}-TRD_name`" />
      <CheckBox :smtext="true" :tostart="true" :name="`beneficiary-${index}-TRD_namecopied`" v-model="data.TRD.namecopied">
        Совпадает с выгодоприобретателем
      </CheckBox>

      <div v-for="obj, idx in data.TRD.data" :key="obj.key">
        <CloseBtn class="step__delbutton" v-if="idx" @click.stop.prevent="() => deleteResidency(idx)" />
        <TextInput :required="true" @setError="errors['country' + idx] = $event" :selectonly="true" :optionsFunction="suggestCountry" v-model="obj.country" text="Страна налогового резиденства" :name="`beneficiary-${index}-TRD_${idx}-country`" />
        <TextInput :required="false" v-model="obj.INN" text="ИНН в стране налогового резиденства" :name="`beneficiary-${index}-TRD_${idx}-INN`" />
      </div>
      <AddBtn class="step5__addbutton" v-if="data.TRD.data.length < 5" @click.stop.prevent="addResidency">Добавить резиденство</AddBtn>
      <TextAreaInput :maxlength="1000" :validation="(v) => (v.length > 1000) ? 'Не более 1000 символов' : ''" @setError="errors.additional = $event" v-model="data.TRD.additional" text="Дополнительные пояснения" :name="`beneficiary-${index}-TRD_additional`" />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import TextInput from '@/components/inputs/TextInput.vue';
import TextAreaInput from '../inputs/TextAreaInput.vue';
import DateInput from '../inputs/DateInput.vue';
import SelInput from '../inputs/SelInput.vue';
import ShortFields from '../ShortFields.vue';
import NumberInput from '../inputs/NumberInput.vue';
import dadataSuggest from '@/mixins/dadataSuggest.js';
import countrySuggest from '../../mixins/countrySuggest';
import CheckBox from '../inputs/CheckBox.vue';
import nameSuggest from '../../mixins/nameSuggest';
import birthdateValidation from '../../mixins/birthdateValidation';
import AddBtn from '../AddBtn.vue';
import CloseBtn from '../CloseBtn.vue';
import RadioGroup from '../inputs/RadioGroup.vue';

export default {
  components: { TextInput, DateInput, SelInput, ShortFields, NumberInput, CheckBox, TextAreaInput, AddBtn, RadioGroup, CloseBtn },
  mixins: [dadataSuggest, nameSuggest, birthdateValidation, countrySuggest],
  props: {
    copyEnabled: { type: Boolean, default: true },
    index: { type: Number, required: true },
    active: { type: Boolean, default: false },
  },
  data: () => ({
    idgen: 0,
    suggestionSuccess: false,
    timer: undefined,
    relationships: ['', 'Супруг/Супруга', 'Внук/Внучка', 'Отец/Мать', 'Усыновитель/Усыновленный', 'Дедушка/Бабушка', 'Сын/Дочь', 'Брат/Сестра (в т.ч. Неполнородные)', 'Другое'],
    doctypeindex: 0,
    errors: {},
    doctypes: ['', 'Паспорт гражданина РФ', 'Паспорт иностранного гражданина', 'Иное'],
    dadataVariants: [],
    timerPDL: undefined,
    dadataVariantsPDL: { full: [], values: [] },
    data: {
      name: '',
      fullcopy: false,
      addresscopy: false,
      birthdate: '',
      doc: {
        type: '',
        series: '',
        number: '',
        code: '',
        code_info: '',
        releasedate: ''
      },
      address: { address: '', flat: '', noflat: false },
      INN: '',
      publicPerson: false,
      PDL: {
        name: '',
        position: '',
        employer: '',
        employer_address: { address: '', flat: '', noflat: false },
        income: {
          salary: false,
          pension: false,
          inherit: false,
          savings: false,
          percentages: false,
          business: false,
          others: ''
        }
      },
      relationship: '',
      insuredperson: {
        copy: false,
        name: '',
        birthdate: ''
      },
      FATCA: {
        enabled: false,
        USACitizen: null,
        USAResidencePermit: null,
        bornInUSA: null,
        renunciation: null,
        longPeriod: null,
        haveaddress: null,
        havephone: null,
        taxResident: null,
        SSN: '',
        ITIN: '',
        name: '',
        agreementItsTrue: false,
        agreementIKnowConsequenses: false
      },
      TRD: {
        enabled: false,
        name: '',
        namecopied: false,
        data: [
          {
            country: '',
            INN: '',
            key: 0
          }
        ],
        additional: ''
      }
    },
  }),
  beforeMount() {
    if (this.form.beneficiaries[this.index])
      this.data = this.form.beneficiaries[this.index]
  },
  computed: {
    ...mapState(['form']),
    dynamicfields() {
      let doctypeindex = this.doctypes.indexOf(this.data.doc.type)
      switch (doctypeindex) {
        case 1:
          return {
            series: true,
            number: true,
            foreignnumber: false,
            code: true,
            releasedate: true
          }
        case 2:
          return {
            series: false,
            number: false,
            foreignnumber: true,
            code: false,
            releasedate: true
          }
        case 0:
        case 3:
        default:
          return {
            series: false,
            number: false,
            foreignnumber: false,
            code: false,
            releasedate: false
          }
      }
    },
    taxResident() {
      return this.data.FATCA.taxResident === 'Да'
    },
    FATCAcondition() {
      return this.form.event.risktype === 'Инвестиционное/накопительное страхование жизни'
    },
    TRDcondition() {
      return this.form.event.risktype === 'Инвестиционное/накопительное страхование жизни'
    },
    filled() {
      for (let key in this.errors)
        if (this.errors[key])
          return false
      if (!this.data.name || !this.data.birthdate || !this.data.doc.type)
        return false
      let required = []
      for (let key in this.dynamicfields)
        if (this.dynamicfields[key])
          if (key == 'foreignnumber')
            required.push('number')
          else
            required.push(key)

      for (let key of required) {
        if (!this.data.doc[key])
          return false
        if (key == 'code' && this.CodeError)
          return false
      }
      if (this.data.publicPerson) {
        let PDLrequired = ['name', 'position', 'employer', 'employer_address']
        for (let key of PDLrequired)
          if (!this.data.PDL[key])
            return false
        if (!this.PDLaddressIsCorrect)
          return false
      }

      if (!this.data.addresscopy && !this.addressIsCorrect)
        return false
      if (!this.data.insuredperson.name || !this.data.insuredperson.birthdate) return false

      required = []

      if (this.FATCAcondition) {
        required.push('FATCA.USACitizen', 'FATCA.USAResidencePermit', 'FATCA.bornInUSA', 'FATCA.renunciation', 'FATCA.longPeriod', 'FATCA.haveaddress', 'FATCA.havephone', 'FATCA.taxResident', 'FATCA.agreementItsTrue', 'FATCA.agreementIKnowConsequenses')
        if (this.taxResident) {
          required.push('FATCA.name')
        }
      }

      if (this.TRDcondition) {
        required.push('TRD.name')
        for (let index in this.data.TRD.data) {
          required.push(`TRD.data.${index}.country`)
          // required.push(`TRD.data.${index}.INN`)
        }
      }

      for (let key of required) {
        let v = this.data
        let parsed
        while (key) {
          let k = key.match(/[^.]*/)[0]
          key = key.replace(k, '').replace(/^\./, '')
          if (k || (key === 0)) {
            v = v[k]
            parsed = true
          }
        }
        if (!parsed || !v)
          return false
      }
      return true
    },
    CodeError() {
      let code = this.data.doc.code
      if (!this.dynamicfields.code || !code || code.length != 7) return ''
      switch (this.suggestionSuccess) {
        case false:
          return 'Ошибка проверки кода'
        case 'error':
          return 'Неверный код подразделения'
        case 'request_wait':
          return 'Ожидание проверки кода...'
        case 'request_sended':
          return 'Идёт проверка кода...'
        case true:
          return ''
        default:
          return ''
      }
    },
    houseIsFilled() {
      if (!(this.dadataVariants?.includes(this.data.address.address)))
        return false
      else {
        let option = this.fullDadataSuggest.find(el => el.value == this.data.address.address)
        if (!option || !option.data.house || !option.data.house_kladr_id)
          return false
        return true
      }
    },
    addressIsCorrect() {
      if (!this.houseIsFilled)
        return false
      if (!this.data.address.noflat && !this.data.address.flat)
        return false
      return true
    },
    PDLhouseIsFilled() {
      if (this.dadataVariantsPDL && this.dadataVariantsPDL.values && !(this.dadataVariantsPDL.values.includes(this.data.PDL.employer_address.address)))
        return false
      else {
        let option = this.dadataVariantsPDL.full.find(el => el.value == this.data.PDL.employer_address.address)
        if (!option || !option.data.house || !option.data.house_kladr_id)
          return false
        return true
      }
    },
    PDLaddressIsCorrect() {
      if (!this.PDLhouseIsFilled)
        return false
      if (!this.data.PDL.employer_address.noflat && !this.data.PDL.employer_address.flat)
        return false
      return true
    },
  },
  methods: {
    deleteResidency(idx) {
      this.data.TRD.data = this.data.TRD.data.filter((el, i) => i != idx)
    },
    addResidency() {
      this.data.TRD.data.push({ country: '', INN: '', key: ++this.idgen })
    },
    clearFields() {
      for (let k of ['name', 'birthdate'])
        if (this.data[k])
          this.data[k] = ''
      for (let k of ['type', 'series', 'number', 'code', 'releasedate'])
        if (this.data.doc[k])
          this.data.doc[k] = ''
    },
    clearDynamicFields() {
      if (this.data.fullcopy) return

      for (let k of ['series', 'number', 'code', 'releasedate'])
        if (this.data.doc[k])
          this.data.doc[k] = ''
    },
    copyAddress() {
      this.data.address = { ...this.form.applicant.address }
    },
    copyAll() {
      this.data.name = this.form.applicant.name
      this.data.birthdate = this.form.applicant.birthdate
      this.data.doc.type = this.form.applicant.doc.type
      this.data.doc.series = this.form.applicant.doc.series
      this.data.doc.number = this.form.applicant.doc.number
      this.data.doc.code = this.form.applicant.doc.code
      this.data.doc.releasedate = this.form.applicant.doc.releasedate
      this.data.addresscopy = true
    },
    async checkCode(code) {
      this.suggestionSuccess = 'request_sended'
      let res = await this.$store.dispatch('suggestCodeLocation', code)
      this.data.doc.code_info = res
      if (res === false)
        return this.suggestionSuccess = false
      if (res && Array.isArray(res)) {
        if (res.length)
          return this.suggestionSuccess = true
        else
          return this.suggestionSuccess = 'error'
      }
      return this.suggestionSuccess = false
    }
  },
  watch: {
    'data.doc.type': function (value, old) {
      if (old && (value != old)) {
        this.clearDynamicFields()
      }
    },
    'data.TRD.namecopied': function (value) {
      if (value)
        this.data.TRD.name = this.data.name
      else
        this.data.TRD.name = ''
    },
    'data.insuredperson.copy': function (v) {
      if (v) {
        this.data.insuredperson.name = this.data.name
        this.data.insuredperson.birthdate = this.data.birthdate
      } else {
        this.data.insuredperson.name = ''
        this.data.insuredperson.birthdate = ''
      }
    },
    FATCAcondition(v) {
      this.data.FATCA.enabled = v
    },
    TRDcondition(v) {
      this.data.TRD.enabled = v
    },
    'data.name': function (value) {
      if (this.data.insuredperson.copy)
        this.data.insuredperson.name = value
      if (this.data.TRD.namecopied)
        this.data.TRD.name = value
    },
    'data.birthdate': function (value) {
      if (this.data.insuredperson.copy)
        this.data.insuredperson.birthdate = value
    },
    filled(v, old) {
      if (v != old)
        this.$emit('filledChanged', v)
    },
    data: {
      handler(v) {
        this.$emit('dataChanged', v)
      },
      deep: true,
    },
    'data.address.address': {
      handler: async function (val) {
        if (this.data.addresscopy) return
        if (!val)
          return this.dadataVariants = []
        clearTimeout(this.timer)
        this.timer = setTimeout(async () => this.dadataVariants = await this.dadataSuggest(val, {
          settings: {
            query: val,
            count: 5,
            "locations": [{ "country": "Россия" }],
            "from_bound": { "value": "city" },
            "to_bound": { "value": "house" }
          }
        }), 200)
      },
      immediate: true
    },
    'data.PDL.employer_address.address': {
      handler: async function (val) {
        if (!val)
          this.dadataVariantsPDL = { full: [], values: [] }
        clearTimeout(this.timerPDL)
        this.timerPDL = setTimeout(async () => {
          this.dadataVariantsPDL = (await this.dadataSuggest(val, {
            split: true,
            settings: {
              query: val,
              count: 5,
              "locations": [{ "country": "Россия" }],
              "from_bound": { "value": "city" },
              "to_bound": { "value": "house" }
            }
          }))
        }, 200)
      },
      immediate: true
    },
    'data.fullcopy': function (val) {
      if (val) {
        this.copyAll()
        this.$emit('setCopy', true)
      }
      else {
        this.$emit('setCopy', false)
        this.data.addresscopy = false
        this.clearFields()
      }
    },
    'data.addresscopy': function (val) {
      if (val)
        this.copyAddress()
      else
        this.data.address = { address: '', flat: '', noflat: false }
    },
    'data.doc.code': {
      handler: async function (code) {
        if (!code || code.length != 7) return this.suggestionSuccess = false
        if (!this.timer) {
          this.checkCode(code)
          this.timer = setTimeout(() => this.timer = undefined, 500)
        }
        else {
          this.suggestionSuccess = 'request_wait'
          clearTimeout(this.timer)
          this.timer = setTimeout(() => {
            this.checkCode(code)
            this.timer = undefined
          }, 500)
        }
      },
      immediate: true
    },
    active() {
      if (this.data.fullcopy)
        this.copyAll()
      if (this.data.addresscopy)
        this.copyAddress()
    }

  }
}
</script>

<style lang="sass">
.step4block-additional
  position: relative
  &__close
    flex-shrink: 0
    position: absolute
    top: 18px
    right: 2px
    z-index: 5
    width: 20px
    height: 20px
    cursor: pointer
    color: black
    @include for-mob
      position: static
      width: 30px
      padding-left: 10px
    svg
      width: 100%
      display: block

</style>